export default __webpack_public_path__ + "static/media/AZFMC_logo.39a5ad07.png";